import { getDateFilterDisplay } from './helpers';
import { FilterItemProps } from './FilterItemDisplay';
import { useTranslation } from 'react-i18next';

const DateFilterItem = ({ filter }: FilterItemProps) => {
    const { t } = useTranslation();
    const dateFilter = getDateFilterDisplay(filter, t);
    return dateFilter;
};

export default DateFilterItem;
